import { Component, OnInit } from '@angular/core';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {
  isArabic: any;
  uploadedFile: any;
  downloadedFilename: any;
  userGuidanceData: any;
  constructor(private storageService: StorageService, private assessmentService: AssessmentService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.assessmentService.fetchUserGuidanceData().subscribe((res: any) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      //console.log('user guide data: ', resp);
      this.userGuidanceData = resp.userGuidanceList;
    });

  }

  fetchUserGuidance(isArabic: boolean) {
    let selectedUserGuidance = this.userGuidanceData.filter((ele: any) => ele.isArabic == isArabic);
    const rqstBody = {
      responseguid: selectedUserGuidance[0].userGuidanceId,
      isDownload: true,
      type:"userguidance"
    }
    this.assessmentService.fetchUploadedFile(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      //console.log('finally files in control assessment: ', resp);
      this.uploadedFile = resp?.documentbody;
      if (this.uploadedFile || resp?.filename) {
        this.downloadedFilename = resp?.filename;
        this.downloadFile(resp?.documentbody, resp?.mimetype);
      }
      //console.log('user guidance file is:', this.uploadedFile);

    });
  }
  downloadFile(linkSource: any, fileType: any) {
    const downloadLink = document.createElement('a');
    linkSource = 'data:' + fileType + ';base64,' + linkSource;
    downloadLink.href = linkSource;
    downloadLink.download = this.downloadedFilename;
    downloadLink.click();
  }
}

